import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import Theme from '../common/NekoTheme';
import { NekoTypo } from '../misc/Typography';
import NekoBusyOverlay from '../common/NekoBusyOverlay';

const Block = Styled.div`
  font-size: ${Theme.fontSizeText};
  margin-bottom: 15px;

  .nui-block-header {
    display: flex;
    justify-content: space-between;
  }

  .nui-block-title {
    color: ${Theme.blue};
    padding: 5px 10px;
    margin-bottom: 5px;
  }

  .nui-block-content {
    background-color: #f1f1f1;
    padding: 26px;
    box-shadow: 0px 2px 5px 0px #0000004a;
    border-radius: 10px;

    p:first-child {
      margin-top: 0;
    }

    p:last-child {
      margin-bottom: 0;
    }
  }

  &.primary {
    padding: 8px;
    background-color: ${Theme.blue};

    .nui-block-title {
      color: ${Theme.white};
    }

    .nui-block-content {
      background-color: ${Theme.white};
    }
  }
`;

/**
 * @oaram {string} className
 */
const StyledNekoBlock = props => {

  const { title, children, className, busy = false, style = {}, action } = props;

  return (
      <Block className={'nui-block ' + (className || '')} style={style}>
        <NekoBusyOverlay busy={busy}>
          <div className="nui-block-header">
            <NekoTypo h2 className="nui-block-title">{title}</NekoTypo>
            {!!action && action}
          </div>
          <div className="nui-block-content">
            {children}
          </div>
        </NekoBusyOverlay>
      </Block>
  );
};

const NekoBlock = (props) => {
  return (<StyledNekoBlock {...props} />);
}

NekoBlock.propTypes = {
  title: PropTypes.string,
  className: PropTypes.oneOf(['', 'primary']),
  style: PropTypes.object,
  action: PropTypes.element,
};

NekoBlock.defaultProps = {
  title: undefined,
  className: '',
  style: {},
  action: undefined,
};

export { NekoBlock };
